module.exports = __webpack_public_path__ + "media/טבח.700d95cc.mp3";